import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const getPropertyBuildingsDone = (_, { payload }) => {
    return [
        ...payload
    ]
}

const initialState = [];

export default createReducer(initialState, {
    [TYPES.GET_PROPERTY_BUILDINGS_DONE]: getPropertyBuildingsDone
});